module.exports = __webpack_public_path__ + "static/media/Angel-Wing.eb68a233.png";